import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box } from "@mui/system";

const ResetDialog = ({
  resetDialogOpen,
  setResetDialogOpen,
  resetBoard
}) => {
  const handleClose = (reset) => {
    if (reset) {
      resetBoard();
    }
    setResetDialogOpen(false);
  };

  return (
    <Dialog
      open={resetDialogOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        style: {
          backgroundColor: "rgb(30, 30, 30)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        },
      }}
    >
      <DialogTitle id="alert-dialog-title" style={{ color: "white" }}>
        RESET
      </DialogTitle>

      <DialogContent>
        <Box display="flex" justifyContent="flex-start">
          <DialogContentText
            id="alert-dialog-description"
            style={{ color: "#b0b0b0" }}
          >
            Do you really want to reset the board?
          </DialogContentText>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => handleClose(true)}
          autoFocus
          variant="contained"
          color="success"
        >
          RESET
        </Button>
        <Button
          onClick={() => handleClose()}
          autoFocus
          variant="contained"
          color="primary"
        >
          CANCEL
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetDialog;
